import { Image } from '@app/components'
import React, { CSSProperties } from 'react'

export const IncIcon = ({ style }: { style?: CSSProperties }) => {
  return <Image preview={false} src="../images/IncIcon.jpeg" style={style} />
}
